<!-- 保密期刊 -->
<template>
<div class="cm_book_container">
    <!-- 标题 -->
    <div class="cm_book_title">
      <h3>{{data.name}}</h3>
      <router-link :to="{path:'/list',query:{urlData:JSON.stringify(data)}}">MORE+</router-link>
    </div>
    <!-- 内容 -->
    <div v-loading="loading" style="min-height:280px">
      <el-carousel :interval="4000" type="card" height="200px">
    <el-carousel-item v-for="item in dataList" :key="item.NEWS_ID" >
      <!--<div  class="cm_book_img">-->
          <div @click="toDetail(item.NEWS_ID,data)" class="cm_book_img">
        <el-image
      style="width: 100%; height: 57%"
      :src="baseUrl+item.ATTACHMENTPIC"
      :fit="imgType" v-if="item.ATTACHMENTPIC"></el-image>
        <!-- <h3 class="medium"  >{{ item.TITLE }}</h3> -->
      </div>
    </el-carousel-item>
  </el-carousel>
    </div>
    </div>
</template>

<script>


export default {
//import引入的组件需要注入到对象中才能使用
components: {},
props:["data"],
data() {
//这里存放数据
return {
  dataList:[],
  baseUrl:window.SITE_CONFIG.baseUrl,
  imgType:"fill",
  loading:true
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  httpPost() {
    this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: this.data.data 
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.pdList
          this.loading = false
        }
          
      });
    },
    toDetail(ID,data){
       this.$router.push({path:'/detail/'+ID,query: {parentData:JSON.stringify(data)}})
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.httpPost()
},

}
</script>
<style scoped>
.cm_book_container {
  width: 390px;
  height: 308px;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
  border: 1px solid rgba(225, 228, 231, 1);
  padding: 0 20px;
  margin-top: 20px;
}

.cm_book_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  border-bottom: 1px solid #4379d3;
}
.cm_book_title > h3 {
  font-size: 20px;
  font-weight: 500;
  color: rgba(67, 121, 211, 1);
  line-height: 33px;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .cm_book_img{
    height: 350px;
  }
</style>